import Signin from "@/pages/Signin";
import Principal from "@/pages/Principal";
import Room from "@/pages/Room";
import Success from "@/pages/Success";
import Ended from "@/pages/Ended";
import Waiting from "@/pages/Waiting";
import Direct from "@/pages/Direct";
import Offline from "@/pages/Offline";

export default [
  {
    path: '/',
    redirect: "/principal/1/signin"
  },
  {
    path: '/direct',
    component: Direct,
    name: "Direct"
  },
  {
    path: '/principal/:empID',
    component: Principal,
    children: [
      { path: 'signin', component: Signin, name: "Signin" },
      { path: 'waiting', component: Waiting, name: "Waiting" },
      { path: 'success', component: Success, name: "Success" },
      { path: 'ended', component: Ended, name: "Ended" },
      { path: 'room/:roomID', component: Room, name: "Room" },
      { path: 'offline', component: Offline, name: "Offline" },
    ]
  }
];
